import React from 'react';
import { createIcon } from '@chakra-ui/react';

const ShareIcon = createIcon({
  displayName: 'ShareIcon',
  viewBox: '0 0 12 14',
  path: (
    <path
      d='M9.69468 9.62014C9.22672 9.62014 8.80802 9.8109 8.48783 10.1098L4.0976 7.47087C4.12839 7.32462 4.15302 7.17837 4.15302 7.02576C4.15302 6.87315 4.12839 6.7269 4.0976 6.58065L8.43857 3.96719C8.77107 4.28513 9.20825 4.48225 9.69468 4.48225C10.7168 4.48225 11.5419 3.63018 11.5419 2.57462C11.5419 1.51907 10.7168 0.666992 9.69468 0.666992C8.67255 0.666992 7.84746 1.51907 7.84746 2.57462C7.84746 2.72723 7.87209 2.87348 7.90288 3.01974L3.56191 5.63319C3.22941 5.31525 2.79223 5.11813 2.30579 5.11813C1.28367 5.11813 0.458572 5.97021 0.458572 7.02576C0.458572 8.08132 1.28367 8.93339 2.30579 8.93339C2.79223 8.93339 3.22941 8.73627 3.56191 8.41833L7.94598 11.0636C7.91519 11.1971 7.89672 11.337 7.89672 11.4769C7.89672 12.5007 8.70334 13.3337 9.69468 13.3337C10.686 13.3337 11.4926 12.5007 11.4926 11.4769C11.4926 10.4531 10.686 9.62014 9.69468 9.62014Z'
      fill='currentColor'
    />
  ),
});

export default ShareIcon;
